// @flow

import { Grid } from 'semantic-ui-react';
import React from 'react';
import { useFormikContext } from 'formik';

import {
  APPLY_SYSTEM_GENERATED_DISCOUNTS_CONFIG,
  APPLY_SYSTEM_GENERATED_GLOBAL_DISCOUNTS_CONFIG,
} from '../../common/vbd/constants';
import { GlobalDiscountProvidedByLabelContainer } from '../../../components/custom-discounts/global-discount/GlobalDiscountProvidedByLabelContainer';
import { getIfAnyMetricIsBeingEdited } from '../../../components/custom-discounts/utils';
import { VBDLegendContainer } from '../../../components/common/vbd/VBDLegendContainer';
import { Spacer } from '../../presentational/spacing/Spacer';

import { GDAndMLDSystemGenerationToggleContainer } from './GDAndMLDSystemGenerationToggleContainer';
import { GlobalDiscountNoteContainer } from './GlobalDiscountNoteContainer';
import { GlobalDiscountsUpdateButtonContainer } from './GlobalDiscountsUpdateButtonContainer';
import { GlobalDiscountLabelContainer } from './GlobalDiscountLabelContainer';
import { GlobalDiscountsTextFieldContainer } from './GlobalDiscountsTextFieldContainer';

export const GlobalDiscountContainer = ({ readOnlyMode }) => {
  const formik = useFormikContext();
  const { values } = formik;
  const shouldGDAndSGEnableBeDisabled = readOnlyMode || getIfAnyMetricIsBeingEdited(values);

  return (
    <>
      <VBDLegendContainer />
      <Spacer y={20} />
      <span
        style={{
          marginLeft: '17px',
        }}
      >
        <GDAndMLDSystemGenerationToggleContainer
          config={APPLY_SYSTEM_GENERATED_GLOBAL_DISCOUNTS_CONFIG}
          readOnlyMode={shouldGDAndSGEnableBeDisabled}
        />
        <GDAndMLDSystemGenerationToggleContainer
          config={APPLY_SYSTEM_GENERATED_DISCOUNTS_CONFIG}
          readOnlyMode={shouldGDAndSGEnableBeDisabled}
        />
      </span>

      <Spacer y={30} />
      <GlobalDiscountProvidedByLabelContainer />
      <Grid columns={4} stackable={true}>
        <Spacer y={12} />
        <Grid.Column textAlign="middle" width={2}>
          <GlobalDiscountLabelContainer />
        </Grid.Column>
        <Grid.Column textAlign="middle" width={2}>
          <GlobalDiscountsTextFieldContainer readOnlyMode={shouldGDAndSGEnableBeDisabled} />
        </Grid.Column>
        <Grid.Column textAlign="middle" width={1}>
          <GlobalDiscountsUpdateButtonContainer readOnlyMode={readOnlyMode} />
        </Grid.Column>
        <Grid.Column textAlign="middle" width={5}>
          <GlobalDiscountNoteContainer />
        </Grid.Column>
      </Grid>
      <Spacer y={60} />
    </>
  );
};

// todo::GDCNBCA Remove the manual span styling
